import React from 'react';
import { useParams } from 'react-router-dom';
import CreateVendorOnboarding from './CreateVendorOnboarding';

const EditVendorOnboarding = () => {
  const { id } = useParams();

  return <CreateVendorOnboarding editMode={true} vendorId={id} />;
};

export default EditVendorOnboarding;

